import * as MediaPlayerActions from '../player.actions';
const { Event } = window;
export const initSubscriptions = (storeAPI, amp) => {
    //console.log("[MediaPlayer Middleware] subscriptions",amp.mediaElement);
    
    let subscriptions = [];
    const { AmpEventsSources } = amp;
    const { dispatch } = storeAPI;
    if (amp.playState === "playing") {
        const data = amp.AmpEventsSources.getEventData(new Event("playing"), amp);
        dispatch(MediaPlayerActions.playerEventPlaying(data))
    }
    else if( amp.playState === "ended") {
        const data = amp.AmpEventsSources.getEventData(new Event("ended"), amp);
        dispatch(MediaPlayerActions.playerEventEnded(data))
    }
    const playing$ = AmpEventsSources.playing.subscribe(data => {
        dispatch(MediaPlayerActions.playerEventPlaying(data))
    })
    /*
    const loadeddata$ = AmpEventsSources.loadeddata.subscribe(data => {
        dispatch(MediaPlayerActions.playerEventLoadedData(data))
    })
    subscriptions.push(loadeddata$);
    */
    const mediachange$ = AmpEventsSources.mediachange.subscribe(data => {
        dispatch(MediaPlayerActions.playerEventMediaChange(data))
    })
    

    const ended$ = AmpEventsSources.ended.subscribe(data => {
        dispatch(MediaPlayerActions.playerEventEnded(data))
    })
    const paused$ = AmpEventsSources.paused.subscribe(data => {
        dispatch(MediaPlayerActions.playerEventPaused(data))
    })
    /*
    const mutechange$ = AmpEventsSources.mutechange.subscribe(data => {
        dispatch(MediaPlayerActions.playerEventMuteChange(data));
    })
    subscriptions.push(mutechange$);
    */
    /*
    const timeupdate$ = AmpEventsSources.timeupdate.subscribe(data => {
        dispatch(MediaPlayerActions.playerEventTimeupdate(data));
    })
    subscriptions.push(timeupdate$);
    */
    
    const destroy$ = AmpEventsSources.destroy.subscribe(data => {
        destroySubscriptions(subscriptions);        
    })

    subscriptions.push(playing$);
    subscriptions.push(mediachange$)
    subscriptions.push(ended$);
    subscriptions.push(paused$);

    
    subscriptions.push(destroy$);
}
export const destroySubscriptions = (subscriptions = []) => {
    subscriptions.forEach(subscription => {
        subscription.unsubscribe();
    });
}